import { createActions } from 'redux-actions';

export const actions = createActions({
  IMPERSONATION: {
    SET_RECENTLY_IMPERSONATED_CLIENT_IDS: payload => payload,
    HYDRATE_RECENTLY_IMPERSONATED_CLIENT_IDS: payload => payload,
    SAVE_RECENTLY_IMPERSONATED_CLIENT_ID: payload => payload,
  },
}).impersonation;
